// Grid column definitions for the Cost Library. Visibility is persisted per user.
export const COLUMNS = [
  { key: "item_type", label: "Type", width: "70px" },
  { key: "item_number", label: "Item #", width: "110px", mono: true },
  { key: "name", label: "Name", width: "280px" },
  { key: "description", label: "Description", width: "240px" },
  { key: "manufacturer", label: "Manufacturer", width: "160px" },
  { key: "category_tier1", label: "Cost Code", width: "170px" },
  { key: "uom", label: "UoM", width: "60px" },
  { key: "unit_cost", label: "Unit Cost", width: "100px", align: "right", editable: true },
  { key: "labor_hours_per_unit", label: "Labor Hrs/Unit", width: "100px", align: "right", editable: true },
  { key: "taxable", label: "Taxable", width: "70px" },
  { key: "cost_code", label: "Cost Code #", width: "110px", mono: true, sortable: false },
  { key: "cost_type", label: "Cost Type", width: "80px", mono: true, sortable: false },
  { key: "budget_code", label: "Budget Code", width: "130px", mono: true, sortable: false },
  { key: "flags", label: "Flags", width: "170px", sortable: false },
  { key: "updated_at", label: "Last Updated", width: "110px" },
  { key: "source", label: "Source", width: "110px" },
];

export const DEFAULT_VISIBLE = [
  "item_type", "item_number", "name", "manufacturer", "category_tier1", "uom",
  "unit_cost", "labor_hours_per_unit", "budget_code", "flags",
];

export const STORAGE_KEY = "abs-pricelist-columns";
